import React, { Component, Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "../styles"
import { connect } from "react-redux"
import Context from "../context"
import {
  Typography,
  DialogContent,
  Icon,
  Chip,
  TextField,
  Avatar,
  Tooltip,
  Hidden,
  Paper,
  Grid,
  Menu,
  IconButton,
} from "@material-ui/core"
import AutoComplete from "../../AutoComplete"
import LoadingIndicator from "../../LoadingIndicator"
import update from "immutability-helper"
import MaskedInput from "react-text-mask"
import {
  getUser,
  toggleCreateUserDialog,
  toggleProfileDialog,
} from "../../../actions/users"
import Image from "../../../assets/images/login_bg.jpg"
import { searchShootsCrew } from "../../../actions/shoots"
import { getParentChildRoles } from "../../../actions/roles"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import Box from "@material-ui/core/Box"
import CancelIcon from "@material-ui/icons/Cancel"
import CachedIcon from "@material-ui/icons/Cached"
import {
  listCrew,
  searchCrew,
  clearCrewFromChip,
  loadingCrew,
  loadingCrewFromChip,
} from "../../../actions/crew"
import { getUsers } from "../../../actions/misc"

import { some, isEmpty, head, forEach } from "lodash"
import InfiniteScroll from "react-infinite-scroll-component"
import SeachCrewCardList from "../../SeachCrewCardList"

import AddCircleIcon from "@material-ui/icons/AddCircle"
import LoopIcon from "@material-ui/icons/Loop"

import { pluralize } from "inflection"

class Two extends Component {
  state = {
    percentage: 12,
    searchCrew: [],
    currentPage: 1,
    searchValue: "",
    childRoles: [],
    childname: [],
    parentRolesSuggestion: [],
    selectedParentRole: null,
    selectingCrewMember: false,
    responsiveSearchMenuAnchorEl: null,
    shoot: this.context.shoot,
  }

  async componentDidMount() {
    const { context } = this
    const { roleSelected } = this.props

    this.props.setRef(this)
    let query
    //if we are using a shoot
    if (context.shoot.location) {
      query = {
        currentPage: { currentPage: this.state.currentPage },
        locations: {
          city: context.shoot.location.city,
          state: context.shoot.location.state,
        },
      }
    } else {
      query = {
        currentPage: { currentPage: this.state.currentPage },
      }
    }

    if (roleSelected) {
      let name = roleSelected.name
      query.roles = { name }
    }

    await this.props.dispatch(searchCrew(query))
    await this.props.dispatch(listCrew(this.state.currentPage))
    await this.props.dispatch(getParentChildRoles())

    this.props.dispatch(loadingCrew())

    this.setRolesSuggestion()
  }

  setRolesSuggestion = () => {
    const { childParentRoles } = this.props

    let parentRolesSuggestion = []
    childParentRoles &&
      childParentRoles.parents &&
      !isEmpty(childParentRoles.connections) &&
      childParentRoles.parents.map(
        p =>
          childParentRoles.connections.find(x => x.parent_role_id === p.id) &&
          parentRolesSuggestion.push({ id: p.id, name: p.name, rate: null })
      )

    this.setState({
      parentRolesSuggestion: parentRolesSuggestion,
    })
  }

  async componentWillUnmount() {
    const { context } = this
    this.props.dispatch(loadingCrew(true))
  }

  selectPosition = id => {
    this.setState({
      searchValue: "",
    })
    const { context, props } = this
    const { setState, roles } = props
    const role = roles.find(x => x.id === id)
    setState(
      update(context, {
        shoot: {
          newPosition: {
            position: {
              $set: role,
            },
          },
        },
      })
    )
    const query = {
      currentPage: { currentPage: this.state.currentPage },
      roles: { name: role.name },
    }
    // new view load crew card on selecting position
    this.props.dispatch(loadingCrewFromChip())
    this.props.dispatch(clearCrewFromChip())
    this.props.dispatch(searchCrew(query))
  }

  selectCategory = id => {
    this.setState({
      searchValue: "",
    })
    const { context, props, state } = this
    const { setState, roles } = props
    const { parentRolesSuggestion } = state
    const role = parentRolesSuggestion.find(x => x.id === id)
    const query = {
      currentPage: { currentPage: this.state.currentPage },
      roles: { name: role.name },
    }
    // new view load crew card on selecting position
    this.props.dispatch(loadingCrewFromChip())
    this.props.dispatch(clearCrewFromChip())
    this.props.dispatch(searchCrew(query))
  }
  // delay logic for the search user

  selectAndAddPosition = async id => {
    this.setState({
      searchValue: "",
    })
    const { context, props } = this
    const { setState, roles } = props
    const { newPosition } = context.shoot
    const role = await roles.find(x => x.id === id)

    setState(
      update(context, {
        shoot: {
          roles: {
            $push: [
              {
                client_rate: null,
                crew_rate: null,
                switch: null,
                position: role,
              },
            ],
          },
        },
      })
    )
  }

  searchUser = async e => {
    await this.setState({
      searchValue: e.target.value,
      currentPage: 1,
    })
    if (
      this.state.searchValue &&
      !isEmpty(this.state.searchValue) &&
      this.state.searchValue !== " " &&
      this.state.searchValue.length > 2
    ) {
      this.props.dispatch(loadingCrew(true))

      const query = {
        currentPage: { currentPage: this.state.currentPage },
        users: { full_name: this.state.searchValue },
      }

      this.props.dispatch(clearCrewFromChip())
      this.props
        .dispatch(searchCrew(query))
        .then(res => {
          this.setState({ searchCrew: res })
        })
        .catch(err => {
          this.setState({ searchCrew: [] })
        })
      this.props.dispatch(loadingCrew)
    }
    if (this.state.searchValue === "") {
      this.props.dispatch(loadingCrew(true))
      this.props.dispatch(clearCrewFromChip())
      this.props.dispatch(listCrew(this.state.currentPage)).then(res => {
        this.props.dispatch(loadingCrew)
      })
    }
  }

  fetchMoreItems = async () => {
    var query = {}
    //// INPUT VALUES IN SEARCH

    // if (this.state.selectedRole) {
    //   const { name } = this.state.selectedRole
    //   query.roles = { name }
    // }
    // if (this.state.selectedLocation) {
    //   let opts = {}
    //   if (this.state.selectedLocation) {
    //     var location = this.state.selectedLocation.locations
    //     var data = location.split(",")
    //     let state = data[1]
    //     let city = data[0]
    //     opts = { city, state }
    //   }
    //   query.locations = { ...opts }
    // }
    // if (this.state.selectedEquipment) {
    //   const { name } = this.state.selectedEquipment
    //   query.equipment = { name }
    // }
    this.setState({ currentPage: this.state.currentPage + 1 })
    const currentPage = this.state.currentPage
    query.currentPage = { currentPage }

    //   if (this.props.crew.crew.length < this.props.crew.searchcrewLength) {
    //     await this.props.dispatch(searchCrew(query))
    //   }
    // } else {
    // this.setState({ currentPage: this.state.currentPage + 1 })

    if (this.state.searchValue.length < 1) {
      await this.props.dispatch(listCrew(this.state.currentPage))
    }

    // if (this.props.crew.crew.length < this.props.crew.searchcrewLength) {
    //   await this.props.dispatch(listCrew(this.state.currentPage))
    // }
  }

  getCrew = (role, { lat, lon }) => {
    const { context, props } = this
    const search = {
      roles: {
        name: role.name,
      },
      locations: {
        lat,
        lon,
      },
    }
    this.props
      .dispatch(searchShootsCrew(search, context.shoot.id))
      .then(res => {
        this.setState({ searchCrew: res })
      })
      .catch(err => {
        this.setState({ searchCrew: [] })
      })
  }

  selectDefaultCrewPosition = async (id, i) => {
    const { context, props } = this
    const { setState, roles } = props
    const role = roles.find(x => x.id === id)
    setState(
      update(context, {
        shoot: {
          defaultCrews: {
            [i]: {
              shootRole: {
                id: { $set: role.id },
                name: { $set: role.name },
              },
            },
          },
        },
      })
    )
  }

  setDefaultCrewRate = (e, i, name) => {
    const { context, props } = this
    const { setState } = props
    const n = Number
    if (name === "client_rate") {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  client_rate: {
                    $set: e.target.value,
                  },
                  crew_rate: {
                    $set:
                      n(e.target.value) -
                      n(e.target.value) *
                        n(context.shoot.defaultCrews[i].shootRole.percentage) *
                        0.01,
                  },
                },
              },
            },
          },
        })
      )
    } else {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  crew_rate: {
                    $set: e.target.value,
                  },
                  percentage: {
                    $set:
                      (1 -
                        n(e.target.value) /
                          n(
                            context.shoot.defaultCrews[i].shootRole.client_rate
                          )) *
                      100,
                  },
                },
              },
            },
          },
        })
      )
    }
  }

  setRate = (e, name) => {
    const { props, context } = this
    const { setState } = props
    const n = e => Number(e)
    if (name === "client_rate") {
      setState(
        update(context, {
          shoot: {
            newPosition: {
              crew_rate: {
                $set:
                  n(e.target.value) -
                  n(e.target.value) * (n(this.state.percentage) * 0.01),
              },
              client_rate: {
                $set: e.target.value,
              },
            },
          },
        })
      )
    } else {
      setState(
        update(context, {
          shoot: {
            newPosition: {
              crew_rate: {
                $set: e.target.value,
              },
            },
          },
        })
      )
      this.setState({
        percentage:
          (1 - n(e.target.value) / n(context.shoot.newPosition.client_rate)) *
          100,
      })
    }
  }

  handleSwitch = () => {
    const { props, context } = this
    const { setState } = props
    setState(
      update(context, {
        shoot: {
          newPosition: {
            switch: {
              $set: !context.shoot.newPosition.switch,
            },
          },
        },
      })
    )
  }

  addPosition = () => {
    const { props, context } = this
    const { setState } = props
    const { newPosition } = context.shoot
    this.setState({ searchCrew: [] })
    if (context.shoot.newPosition.user) {
      return this.addDefaultCrew()
    }
    setState(
      update(context, {
        shoot: {
          newPosition: {
            client_rate: {
              $set: 0,
            },
            crew_rate: {
              $set: 0,
            },
            switch: {
              $set: false,
            },
            position: {
              $set: null,
            },
            user: {
              $set: null,
            },
          },
          roles: {
            $push: [
              {
                client_rate: newPosition.client_rate,
                crew_rate: newPosition.crew_rate,
                switch: newPosition.switch,
                position: newPosition.position,
              },
            ],
          },
        },
      })
    )
    // focus autocopmlete after adding new position
    try {
      document.querySelector("#add-position-input input[type=text]").focus()
    } catch (err) {}
  }

  setPercentage = e => {
    const { props, context } = this
    const { setState } = props
    const n = Number
    let value = e.target.value.replace("%", "")
    if (value.toString()[0] === "0") {
      value = value.substring(1)
    }
    this.setState({ percentage: value })
    if (context.shoot.newPosition.client_rate) {
      setState(
        update(context, {
          shoot: {
            newPosition: {
              crew_rate: {
                $set:
                  n(context.shoot.newPosition.client_rate) -
                  n(context.shoot.newPosition.client_rate) * (n(value) / 100),
              },
            },
          },
        })
      )
    }
  }

  setDefaultCrewavailable = (e, i) => {
    const { props, context } = this
    const { setState } = props

    if (
      context.shoot.defaultCrews[i] &&
      context.shoot.defaultCrews[i].shootRole
    ) {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  available: {
                    $set: !context.shoot.defaultCrews[i].shootRole.available,
                  },
                  requested: {
                    $set: !context.shoot.defaultCrews[i].shootRole.requested,
                  },
                },
              },
            },
          },
        })
      )
    }
  }

  setDefaultCrewPercentage = (e, i) => {
    const { props, context } = this
    const { setState } = props
    const n = Number
    let value = e.target.value.replace("%", "")
    if (value.toString()[0] === "0") {
      value = value.substring(1)
    }
    if (
      context.shoot.defaultCrews[i] &&
      context.shoot.defaultCrews[i].shootRole &&
      context.shoot.defaultCrews[i].shootRole.client_rate
    ) {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  percentage: {
                    $set: value,
                  },
                  crew_rate: {
                    $set:
                      n(context.shoot.defaultCrews[i].shootRole.client_rate) -
                      n(context.shoot.defaultCrews[i].shootRole.client_rate) *
                        (n(value) / 100),
                  },
                },
              },
            },
          },
        })
      )
    } else {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  percentage: {
                    $set: value,
                  },
                },
              },
            },
          },
        })
      )
    }
  }

  selectUser = async id => {
    const { context, props } = this
    const { setState } = props
    const { newPosition } = context.shoot
    const { childRoles } = this.state

    if (typeof id.id === "number") {
      await setState(
        update(context, {
          shoot: {
            newPosition: {
              user: {
                $set: props.users.find(x => x.id === id.id),
              },
            },
          },
        })
      )

      if (childRoles && !isEmpty(childRoles)) {
        await this.addCrewWithDefaulPosition(head(childRoles))
      } else {
        await this.addDefaultCrew()
      }
    } else {
      props.dispatch(toggleCreateUserDialog(true, {}))
    }
  }

  addCrewWithDefaulPosition = (role, alreadyAdded = false) => {
    const { context, props } = this
    const { setState } = props
    const { shoot } = context
    const { newPosition } = shoot
    const percentage = this.state.percentage
    this.props.dispatch(getUser(newPosition.user.id, false)).then(res => {
      this.setState({ percentage: 12 })
      if (alreadyAdded) {
        setState(
          update(context, {
            shoot: {
              newPosition: {
                client_rate: {
                  $set: 0,
                },
                crew_rate: {
                  $set: 0,
                },
                switch: {
                  $set: false,
                },
                position: {
                  $set: null,
                },
                user: {
                  $set: null,
                },
                requested: {
                  $set: false,
                },
                available: {
                  $set: false,
                },
              },
              defaultCrews: {
                0: {
                  $set: {
                    shootRole: {
                      id: role.id,
                      client_rate: shoot.newPosition.client_rate,
                      crew_rate: shoot.newPosition.crew_rate,
                      name: role.name,
                      percentage,
                      available: shoot.newPosition.available,
                      requested: shoot.newPosition.requested,
                    },
                    id: shoot.newPosition.user.id,
                    ...res,
                  },
                },
              },
            },
          })
        )
      } else {
        setState(
          update(context, {
            shoot: {
              newPosition: {
                client_rate: {
                  $set: 0,
                },
                crew_rate: {
                  $set: 0,
                },
                switch: {
                  $set: false,
                },
                position: {
                  $set: null,
                },
                user: {
                  $set: null,
                },
                requested: {
                  $set: false,
                },
                available: {
                  $set: false,
                },
              },
              defaultCrews: {
                $push: [
                  {
                    shootRole: {
                      id: role.id,
                      client_rate: shoot.newPosition.client_rate,
                      crew_rate: shoot.newPosition.crew_rate,
                      name: role.name,
                      percentage,
                      available: shoot.newPosition.available,
                      requested: shoot.newPosition.requested,
                    },
                    id: shoot.newPosition.user.id,
                    ...res,
                  },
                ],
              },
            },
          })
        )
      }
    })
  }

  addCrewToSelectedRole = async id => {
    const { context, props } = this
    const { setState, roleSelected } = props

    if (typeof id.id === "number") {
      await setState(
        update(context, {
          shoot: {
            newPosition: {
              user: {
                $set: props.users.find(x => x.id === id.id),
              },
            },
          },
        })
      )

      let role = { id: roleSelected.role_id, name: roleSelected.name }

      await this.addCrewWithDefaulPosition(
        role,
        context.shoot.defaultCrews.length > 0 ? true : false
      )
    } else {
      props.dispatch(toggleCreateUserDialog(true, {}))
    }
  }

  addDefaultCrew = () => {
    const { context, props } = this
    const { setState } = props
    const { shoot } = context
    const { newPosition } = shoot
    const percentage = this.state.percentage
    this.props.dispatch(getUser(newPosition.user.id, false)).then(res => {
      this.setState({ percentage: 12 })
      setState(
        update(context, {
          shoot: {
            newPosition: {
              client_rate: {
                $set: 0,
              },
              crew_rate: {
                $set: 0,
              },
              switch: {
                $set: false,
              },
              position: {
                $set: null,
              },
              user: {
                $set: null,
              },
              requested: {
                $set: false,
              },
              available: {
                $set: false,
              },
            },
            defaultCrews: {
              $push: [
                {
                  shootRole: {
                    id: null,
                    client_rate: shoot.newPosition.client_rate,
                    crew_rate: shoot.newPosition.crew_rate,
                    name: null,
                    percentage,
                    available: shoot.newPosition.available,
                    requested: shoot.newPosition.requested,
                  },
                  id: shoot.newPosition.user.id,
                  ...res,
                },
              ],
            },
          },
        })
      )
    })
  }

  getDefaultCrew = e => {}

  selectParentRole = async id => {
    const { childParentRoles } = this.props
    const { parentRolesSuggestion } = this.state
    const selectedParentRole = parentRolesSuggestion.find(x => x.id === id)
    let child = childParentRoles.connections
      .map(
        x =>
          x.parent_role_id == id
            ? childParentRoles.children.find(y => x.child_role_id === y.id)
            : null
      )
      .filter(el => el != null)
    await this.setState({
      childRoles: child,
    })
    let roleNames = []
    child && child.map(c => roleNames.push(c.name))

    const query = {
      currentPage: { currentPage: this.state.currentPage },
      roles: { roleNames: roleNames },
    }
    // new view load crew card on selecting position
    this.props.dispatch(loadingCrewFromChip())
    this.props.dispatch(clearCrewFromChip())
    this.props.dispatch(searchCrew(query))

    this.setState({
      selectedParentRole: selectedParentRole,
    })
  }

  removeChildRole = index => {
    const { childRoles } = this.state

    let newChildRoles = childRoles
    newChildRoles.splice(index, 1)

    this.setState({
      childRoles: newChildRoles,
    })
  }

  refreshChildRoles = () => {
    const { selectedParentRole } = this.state
    const { childParentRoles } = this.props

    let child = childParentRoles.connections
      .map(
        x =>
          x.parent_role_id === selectedParentRole.id
            ? childParentRoles.children.find(y => x.child_role_id === y.id)
            : null
      )
      .filter(el => el != null)
    this.setState({
      childRoles: child,
    })
  }

  onSearchingUser = async (val, name) => {
    const stuff = this.props[pluralize(name).toLowerCase()].find(
      n => n.id === val
    )
    if (typeof val.id === "number") {
      await this.props.dispatch(clearCrewFromChip())

      const newState = stuff ? stuff : val
      this.setState(
        update(this.state, {
          searchValue: {
            $set: newState,
          },
          searchMenuAnchorEl: {
            $set: null,
          },
        })
      )
      setTimeout(() => {
        this.loadCrew()
      }, 100)
    } else {
      this.props.dispatch(toggleCreateUserDialog(true, {}))
    }
  }

  loadCrew = async () => {
    const { context } = this
    let query = {}
    const { full_name } = this.state.searchValue
    query.users = { full_name }

    this.setState({ currentPage: 1 })
    const currentPage = this.state.currentPage
    query.currentPage = { currentPage }
    this.props.dispatch(loadingCrew(true))
    if (full_name) {
      await this.props.dispatch(searchCrew(query))
      this.props.dispatch(loadingCrew())
    } else {
      await this.props.dispatch(listCrew(this.state.currentPage)).then(res => {
        this.props.dispatch(loadingCrew)
        this.setState({ chipActive: false })
      })
    }
  }

  onDelete = async name => {
    await this.setState(
      update(this.state, {
        searchValue: {
          $set: "",
        },
      })
    )
    if (this.state.searchValue === "") {
      this.props.dispatch(clearCrewFromChip())
      this.props.dispatch(loadingCrewFromChip())
      this.props.dispatch(getUsers())
    }
    await setTimeout(() => {
      this.loadCrew()
    }, 100)
  }

  handleOpenSearchMenu = event => {
    this.setState({
      responsiveSearchMenuAnchorEl: event.currentTarget,
    })
  }
  handleCloseSearchMenu = () => {
    this.setState({
      responsiveSearchMenuAnchorEl: null,
    })
  }

  noCrewMembersExistForLocation = () => {
    const crewMembers = this.props.crew.crew
    const shootLocation = this.state.shoot.location
    // const shootLocation = {
    //   city: "Dallas",
    //   state: "Texas",
    //   country: "United States",
    //   lat: 32.7766642,
    //   lon: -96.79698789999998,
    // }
    let noCrewMembersForShootLocation = true
    crewMembers.forEach(crewMember => {
      crewMember.locations.forEach(crewMemberLocation => {
        if (
          crewMemberLocation.city === shootLocation.city &&
          crewMemberLocation.state === shootLocation.state
        ) {
          noCrewMembersForShootLocation = false
        }
      })
    })
    return noCrewMembersForShootLocation
  }

  render() {
    const { context, props, state } = this
    const { classes, setState, roles, users, roleSelected } = props
    const { newPosition } = context.shoot
    const {
      parentRolesSuggestion,
      selectedParentRole,
      responsiveSearchMenuAnchorEl,
    } = state
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth

    const positionCrew = c => {
      return c.map((crew, i) => (
        <Grid
          key={`role-${i + 1}`}
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className={classes.padding}
        >
          <Box className={classes.backgroundLight}>
            <Avatar
              className={[classes.purple, classes.large, classes.alignSelf]}
              src={
                crew.profile_image.secure_url
                  ? crew.profile_image.secure_url
                  : Image
              }
            />
            <div className={classes.PositionInfo}>
              <Typography
                component="p"
                className={[classes.noteLineTextCrew, classes.marginLeft]}
              >
                {crew.first_name + " " + crew.last_name}
              </Typography>
              {crew.shootRole && crew.shootRole.id ? (
                <Tooltip title="Remove Position" placement="top">
                  <Typography
                    component="p"
                    className={[
                      classes.positionText,
                      classes.marginLeft,
                      classes.pointer,
                    ]}
                    onClick={e =>
                      setState(
                        update(context, {
                          shoot: {
                            defaultCrews: {
                              [i]: {
                                shootRole: {
                                  id: { $set: null },
                                  name: { $set: null },
                                },
                              },
                            },
                          },
                        })
                      )
                    }
                  >
                    {crew.shootRole && crew.shootRole.name}
                  </Typography>
                </Tooltip>
              ) : (
                <div style={{ minWidth: "180px" }}>
                  <AutoComplete
                    placeholder="Search Position"
                    // onChange={this.selectPosition}
                    onChange={value => this.selectDefaultCrewPosition(value, i)}
                    suggestions={roles}
                    labelKey="name"
                    showValue
                    // value={newPosition.position}
                    prop={this.props}
                  />
                </div>
              )}
            </div>
            <CancelIcon
              className={
                crew.shootRole && crew.shootRole.id
                  ? classes.Icon
                  : classes.SelectPositionIcon
              }
              onClick={e =>
                setState(
                  update(context, {
                    shoot: {
                      defaultCrews: {
                        [i]: {
                          shootRole: {
                            $set: null,
                          },
                        },
                        $splice: [[i, 1]],
                      },
                    },
                  })
                )
              }
            />
          </Box>
        </Grid>
      ))
    }
    const positions = (data, crew) => {
      const extra = crew ? positionCrew(crew) : []
      // shot selected crew first
      return extra.concat(
        data.map((x, i) => {
          return (
            <div
              key={i}
              style={{
                display: "flex",
                margin: "26px",
                alignItems: "center",
              }}
            >
              <Chip
                avatar={
                  <Avatar
                    className={classes.closeAvatar}
                    onClick={e =>
                      setState(
                        update(context, {
                          shoot: {
                            roles: {
                              $splice: [[i, 1]],
                            },
                          },
                        })
                      )
                    }
                  >
                    <Icon className={classes.closeIcon}>close</Icon>
                  </Avatar>
                }
                color="primary"
                label={x.position && x.position.name}
                style={{ color: "white" }}
              />
            </div>
          )
        })
      )
    }

    return (
      <Fragment>
        {/* title section */}
        <div className={classes.title}>
          <DialogContent>
            <Typography gutterBottom className={classes.white} variant="h6">
              Add Crew
            </Typography>
          </DialogContent>
        </div>
        {/* end title section */}
        {/* positions section */}
        <DialogContent style={{ overflow: "hidden" }}>
          {!roleSelected &&
            (isEmpty(context.shoot.defaultCrews) &&
              isEmpty(context.shoot.roles)) && (
              <div className={classes.margin}>
                <Typography component="p" className={classes.noPositionText}>
                  No position added
                </Typography>
              </div>
            )}
          <Grid container>
            {positions(context.shoot.roles, context.shoot.defaultCrews)}
          </Grid>
          {!roleSelected && (
            <div className={classes.positionsWrapper}>
              <div
                style={{
                  minWidth: "200px",
                  display: "flex",
                  marginTop: "10px",
                  marginLeft: "10px",
                }}
              >
                <AutoComplete
                  placeholder="Search Role"
                  onChange={this.selectParentRole}
                  suggestions={parentRolesSuggestion}
                  labelKey="name"
                  showValue
                  value={selectedParentRole}
                  id="add-position-input"
                  prop={this.props}
                />
              </div>

              {/* WEB VIEW */}
              <Hidden smDown>
                <div
                  style={{
                    marginRight: "50px",
                    marginTop: "10px",
                    display: "flex",
                  }}
                >
                  {this.state.searchValue && (
                    <Chip
                      label={this.state.searchValue.full_name}
                      className={this.props.classes.chip}
                      classes={{
                        deleteIcon: this.props.classes.chipDeleteIcon,
                      }}
                      deleteIcon={
                        <CancelIcon onTouchEnd={() => this.onDelete("User")} />
                      }
                      onDelete={() => this.onDelete("User")}
                    />
                  )}
                  <AutoComplete
                    placeholder="Search Name"
                    creatable
                    formatCreateLabel={value => "Create new crew member"}
                    showValue
                    value={
                      this.state.searchValue && this.state.searchValue.full_name
                    }
                    onChange={val => {
                      this.onSearchingUser(val, "User")
                    }}
                    labelKey="full_name"
                    // formatCreateLabel={value => `Search ${value}`}
                    prop={this.props}
                  />
                </div>
              </Hidden>

              {/* MOBILE VIEW */}
              <Hidden mdUp>
                {this.state.searchValue && (
                  <Chip
                    label={this.state.searchValue.full_name}
                    className={this.props.classes.chip}
                    classes={{
                      deleteIcon: this.props.classes.chipDeleteIcon,
                    }}
                    deleteIcon={
                      <CancelIcon onTouchEnd={() => this.onDelete("User")} />
                    }
                    onDelete={() => this.onDelete("User")}
                  />
                )}
                <IconButton onClick={e => this.handleOpenSearchMenu(e)}>
                  <Icon>search</Icon>
                </IconButton>
                <Menu
                  anchorEl={responsiveSearchMenuAnchorEl}
                  open={Boolean(responsiveSearchMenuAnchorEl)}
                  onClose={e => this.handleCloseSearchMenu(e)}
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  // className={this.props.classes.MenuHeight}
                  autoFocus
                  classes={{
                    paper: this.props.classes.MenuHeight,
                    list: this.props.classes.MenuHeight,
                  }}
                >
                  {/* <MenuItem style={{ height: "30%" }}> */}
                  <AutoComplete
                    placeholder="Search Name"
                    creatable
                    showValue
                    value={
                      this.state.searchValue && this.state.searchValue.full_name
                    }
                    onChange={val => {
                      this.onSearchingUser(val, "User")
                    }}
                    labelKey="full_name"
                    // formatCreateLabel={value => `Search ${value}`}
                    formatCreateLabel={value => "Create new crew member"}
                    prop={this.props}
                  />
                  {/* </MenuItem> */}
                </Menu>
              </Hidden>
            </div>
          )}

          {roleSelected && (
            <div className={classes.positionsWrapper}>
              <div
                style={{
                  minWidth: "200px",
                  display: viewportWidth > 600 ? "flex" : "",
                  marginTop: "10px",
                  marginLeft: "10px",
                  width: viewportWidth < 600 ? "80%" : {},
                }}
              >
                <Hidden smDown>
                  <Paper elevation={3} className={classes.positionSlide}>
                    <Typography
                      component="p"
                      style={{ fontSize: "0.9em", alignSelf: "center" }}
                    >
                      {roleSelected.name}
                    </Typography>
                  </Paper>
                </Hidden>

                <Hidden mdUp>
                  <Paper elevation={3} className={classes.positionSlideMobile}>
                    <Typography
                      component="p"
                      style={{ fontSize: "0.9em", alignSelf: "center" }}
                    >
                      {roleSelected.name}
                    </Typography>
                  </Paper>
                </Hidden>
              </div>

              <div
                style={
                  viewportWidth > 600
                    ? { minWidth: "180px", marginTop: "11px" }
                    : { marginTop: "15px" }
                }
              >
                <TextField
                  variant="outlined"
                  value={this.state.searchValue}
                  onChange={e => this.searchUser(e)}
                  label="Search Crew Member"
                  style={viewportWidth > 600 ? {} : { width: "100%" }}
                />

                {/* <AutoComplete
                    placeholder="Search Name"
                    creatable
                    showValue
                    value={this.state.searchValue && this.state.searchValue.full_name}
                    onChange={val => { this.onSearchingUser(val, "User") }}
                    labelKey="full_name"
                    // formatCreateLabel={value => `Search ${value}`}
                    formatCreateLabel={value => "Create new crew member"}
                    prop={this.props}
                  /> */}
              </div>
            </div>
          )}

          {!roleSelected &&
            this.state.childRoles &&
            !isEmpty(this.state.childRoles) && (
              <Grid container style={{ display: "flex" }}>
                <Grid
                  item
                  style={{
                    width: "90%",
                    //overflowX: "auto",
                    display: "flex",
                  }}
                >
                  {this.state.childRoles.map((role, index) => (
                    <Chip
                      icon={
                        <Tooltip title="Add Position to Shoot" placement="top">
                          <AddCircleIcon
                            className={this.props.classes.chipAddIcon}
                            onClick={() => this.selectAndAddPosition(role.id)}
                          />
                        </Tooltip>
                      }
                      label={role.name}
                      className={this.props.classes.chip}
                      classes={{
                        deleteIcon: this.props.classes.chipDeleteIcon,
                      }}
                      deleteIcon={
                        <Tooltip title="Remove Position" placement="top">
                          <CancelIcon />
                        </Tooltip>
                      }
                      onDelete={() => this.removeChildRole(index)}
                    />
                  ))}
                </Grid>

                <Grid item style={{ display: "flex" }}>
                  <Tooltip title="Refresh Positions" placement="top">
                    <CachedIcon
                      className={classes.controls}
                      onClick={() => this.refreshChildRoles()}
                    />
                  </Tooltip>
                </Grid>
              </Grid>
            )}

          <section className={this.props.classes.crewSection}>
            <div className={this.props.classes.contentWrapper}>
              <LoadingIndicator working={this.props.crew.loadingCrew}>
                Loading Crew Members
              </LoadingIndicator>
              {this.props.crew.crew.length > 0 && (
                <InfiniteScroll
                  next={this.fetchMoreItems}
                  hasMore={true}
                  dataLength={this.props.crew.crew.length}
                  loader={
                    this.props.crew.searchcrewLength > 100 &&
                    this.props.crew.crew.length <
                      this.props.crew.searchcrewLength && <h4>Loading...</h4>
                  }
                  height="60vh"
                >
                  <div className={this.props.classes.crewSectionWrapper}>
                    {this.noCrewMembersExistForLocation() && (
                      <Typography
                        component="p"
                        className={classes.noCrewMembersForLocation}
                      >
                        No Crew Members local to{" "}
                        {this.state.shoot.location.city},{" "}
                        {this.state.shoot.location.state}
                      </Typography>
                    )}
                    <Grid container>
                      {this.props.crew.crew.map((crew, index) => {
                        const isMe =
                          this.props.authentication.authenticatedUser.id ===
                          crew.id
                        return (
                          <Grid
                            item
                            lg={3}
                            md={4}
                            xs={12}
                            style={{ display: "flex", flexBasis: "10%" }}
                          >
                            <Fragment key={index}>
                              <div
                                data-id={crew.id}
                                className={this.props.classes.crewCardWrapper}
                              >
                                {this.state.selectingCrewMember && (
                                  <div
                                    className={
                                      this.props.classes.selectedCrewMemberCheck
                                    }
                                  >
                                    <LoopIcon
                                      className={this.props.classes.iconColor}
                                    />
                                  </div>
                                )}

                                {context.shoot.defaultCrews &&
                                  context.shoot.defaultCrews.some(
                                    x => x.id === crew.id
                                  ) && (
                                    <div
                                      className={
                                        this.props.classes
                                          .selectedCrewMemberCheck
                                      }
                                    >
                                      <CheckCircleIcon
                                        className={this.props.classes.iconColor}
                                      />
                                    </div>
                                  )}
                                <SeachCrewCardList
                                  crew={crew}
                                  currentUser={
                                    this.props.authentication.authenticatedUser
                                  }
                                  accessLevel={this.props.accessLevel}
                                  activeCompany={this.props.activeCompany}
                                  onOpenProfile={async () => (
                                    await this.setState({
                                      selectingCrewMember: true,
                                    }),
                                    roleSelected
                                      ? this.addCrewToSelectedRole(crew)
                                      : context.shoot.defaultCrews &&
                                        context.shoot.defaultCrews.some(
                                          x => x.id === crew.id
                                        )
                                        ? await setState(
                                            update(context, {
                                              shoot: {
                                                defaultCrews: {
                                                  [context.shoot.defaultCrews.findIndex(
                                                    x => x.id === crew.id
                                                  )]: {
                                                    shootRole: {
                                                      $set: null,
                                                    },
                                                  },
                                                  $splice: [
                                                    [
                                                      context.shoot.defaultCrews.findIndex(
                                                        x => x.id === crew.id
                                                      ),
                                                      1,
                                                    ],
                                                  ],
                                                },
                                              },
                                            })
                                          )
                                        : await this.selectUser(crew),
                                    this.setState({
                                      selectingCrewMember: false,
                                    })
                                  )}
                                  onViewProfile={() =>
                                    this.props.dispatch(
                                      toggleProfileDialog(true, { id: crew.id })
                                    )
                                  }
                                  onOpenMessageDrawer={this.openMessageDrawer}
                                  ratingChanged={val =>
                                    this.ratingChanged(val, crew)
                                  }
                                  isPositionSearch={
                                    this.state.selectedRole || false
                                  }
                                  onRemoveFromCompany={this.removeFromCompany}
                                  history={this.props.history}
                                  className={
                                    this.state.selectingCrewMember
                                      ? classes.selectingCrewMember
                                      : context.shoot.defaultCrews &&
                                        context.shoot.defaultCrews.some(
                                          x => x.id === crew.id
                                        )
                                        ? classes.selectedCrewMember
                                        : {}
                                  }
                                  isUserSelected={
                                    context.shoot.defaultCrews &&
                                    context.shoot.defaultCrews.some(
                                      x => x.id === crew.id
                                    )
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Fragment>
                          </Grid>
                        )
                      })}
                    </Grid>
                  </div>
                  {}
                </InfiniteScroll>
              )}
            </div>
            {}
          </section>
          {/* } */}
        </DialogContent>
      </Fragment>
    )
  }
}

Two.contextType = Context
// controlls disabled prop of next/save button
Two.allowNext = state => {
  let flag = 0
  if (!isEmpty(state.shoot.defaultCrews)) {
    state.shoot.defaultCrews.forEach(crew => {
      if (!crew.shootRole || (crew.shootRole && crew.shootRole.id === null)) {
        flag = 1
      }
    })
  } else {
    if (!isEmpty(state.shoot.roles)) {
      flag = 0
    } else {
      flag = 1
    }
  }
  return flag === 1
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    open: state.shoots.showDialog,
    // roles: state.misc.roles,
    roles: state.misc.allRoles,
    childParentRoles: state.misc.childParentRoles,
    users: state.misc.users,
    crew: state.crew,
    locations: state.misc.locations,
    equipment: state.misc.equipment,
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
    crewlength: state.crewlength,
    searchcrewLength: state.searchcrewLength,
    crewModal: state.users.crewModal,
    setModal: state.users.setModal,
    roleSelected: state.shoots.roleSelected,
  }
}

const connector = connect(mapStateToProps)

export default withStyles(styles, { withTheme: true })(connector(Two))
